import { MdClose } from "react-icons/md";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
  Icon,
} from ".";

interface Props {
  onConfirm?: () => any;
  title?: string;
  description?: string;
  confirmText?: string;
  onClose?: () => void;
  open?: boolean;
  className?: string;
  children?: React.ReactNode;
}

export const ConfirmDeleteDialog = ({
  title = "Confirm Deletion",
  description = "Are you sure you want to delete? This action cannot be undone.",
  confirmText = "Delete",
  onConfirm,
  onClose,
  open,
  className,
  children,
}: Props) => {
  return (
    <AlertDialog onOpenChange={onClose} open={open}>
      {children && <AlertDialogTrigger asChild>{children}</AlertDialogTrigger>}

      <AlertDialogContent className={className}>
        <div className="flex h-12 items-center justify-between">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-danger-100">
            <Icon name="Trash2" className="h-6 w-6 text-danger-500" />
          </div>

          <AlertDialogCancel className="border-0 p-0">
            <MdClose className="h-6 w-6 text-neutral-500" />
          </AlertDialogCancel>
        </div>

        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onClose}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            className="bg-danger-500 text-white hover:bg-danger-600"
            onClick={onConfirm}
          >
            {confirmText}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
